<template>
  <div className="flex pt-16 justify-center min-w-full min-h-screen bg-gray-100">
    <div className="w-2/3 lg:w-1/3">
      <div class="flex justify-center pb-8 max-w-sm">
        <h1 class="text-2xl font-bold font-sans text-greenPrimary">Citra Satellite</h1>
        <!-- <img src="../../assets/logo-seahub.png" width="150"/> -->
      </div>
      <CardComponent>
        <h1 className="font-semibold text-xl text-center text-greenPrimary uppercase">
          Register
        </h1>
        <p class="text-center mb-5 text-gray-500">Sign Up New Account</p>
        <AlertSuccessComponent v-if="success" message="Register new account success" />
        <Form
          name="form-register"
          @submit="onSubmit"
          :validation-schema="schema"
          v-slot="{ errors, isSubmitting }"
        >
          <InputWithLabel label="Name *" type="text" name="name" :error="errors.name" />
          <InputWithLabel
            label="Username *"
            type="text"
            name="username"
            :error="errors.username"
          />
          <InputWithLabel
            label="Password *"
            type="password"
            name="password"
            :error="errors.password"
          />
          <ButtonComponent vClass="w-full bg-darkGreen" :loading="isSubmitting"
            >Sign Up</ButtonComponent
          >
          <span class="text-xs font-sans font-semibold text-gray-700"
            >Already have an account?
            <a class="text-red-800" href="/login">Sign In</a></span
          >
        </Form>
        <!-- <div class="text-center">
          <p>OR</p>
          <GoogleLogin :callback="callback"/>
          </div> -->
      </CardComponent>
    </div>
  </div>
</template>

<script>
import { Form } from "vee-validate";
import CardComponent from "@/components/CardComponent.vue";
import InputWithLabel from "@/components/InputWithLabel.vue";
import ButtonComponent from "@/components/ButtonComponent.vue";
import AlertSuccessComponent from "@/components/AlertSuccessComponent.vue";
import * as Yup from "yup";
import { useErrorStore } from "@/store";
import { ref } from "vue";
import axios from "axios";

export default {
  components: {
    Form,
    CardComponent,
    InputWithLabel,
    ButtonComponent,
    AlertSuccessComponent,
  },
  setup() {
    const callback = (response) => {
      // This callback will be triggered when the user selects or login to
      // his Google account from the popup
      console.log("Handle the response", response);
    };

    const schema = Yup.object().shape({
      name: Yup.string().required("Name is required"),
      username: Yup.string().required("Username is required"),
      password: Yup.string()
        .required("Password is required")
        .min(8, "Password must be at least 8 characters")
        .matches(/[a-zA-Z]/, "Password must contain at least 1 letter and 1 number")
        .matches(/\d/, "Password must contain at least 1 letter and 1 number"),
    });

    const errorStore = useErrorStore();
    const success = ref(false);

    async function onSubmit(value) {
      const baseUrl = process.env.VUE_APP_API_URL;
      const { name, username, password } = value;
      try {
        await axios.post(baseUrl + "users", {
          name: name,
          username: username,
          password: password,
          role: "user",
        });
        success.value = true;
        document.getElementsByName("form-register")[0].reset();
      } catch (error) {
        errorStore.open = true;
        errorStore.message = error.response.data.message
          ? error.response.data.message
          : errorStore.message;
        console.log(error);
      }
    }

    return {
      onSubmit,
      schema,
      success,
      callback,
    };
  },
};
</script>

<style></style>
